
import axios from "axios";
import { API_ENDPOINTS } from "../../api/apiEndpoints";

const ShowDocuments = ({documents, fileCount}) => {
    // Download handler function
    const handleDownload = async (key) => {
        const res = await axios.get(`${import.meta.env.VITE_BASE_URL}/preview-file/${encodeURIComponent(key)}`);
        window.open(res.data.url, '_blank', "noopener,noreferrer");
    };

    return(
        <div className="mt-2 flex flex-col gap-4 bg-white shadow-md rounded-lg">
            <table className="min-w-full bg-white border-b border-gray-200 rounded-lg table-fixed text-sm">
                <thead key='thead'>
                    <tr key='header-row' className="text-[#94A3B8] bg-[#E2E8F0]">
                        <th key="header-filename" className="p-4 border-b w-[70%] text-start">File Name</th>
                        <th key="header-upload-date" className="p-4 border-b text-center w-[15%]">Upload Date</th>
                        <th key="header-action" className="p-4 border-b text-center w-[15%]">Action</th>
                    </tr>
                </thead>
                <tbody key='tbody'>
                    {fileCount > 0 ? (
                        documents.map((file, index) => (
                            <tr key={index} className="text-[#1E293B] border-b border-gray-200 text-sm hover:bg-[#F7F7F7]">
                                <td key={`${index}-filename`} className="p-4 text-start font-bold w-[70%]">{file.filename}</td>
                                <td key={`${index}-upload-date`} className="p-4 text-center w-[15%]">
                                    {new Date(file.last_modified).toLocaleDateString('en-GB',{
                                        day: '2-digit',
                                        month: 'short', 
                                        year: 'numeric',
                                    })}
                                </td>
                                <td key={`${index}-action`} className="p-4 text-center w-[15%]">
                                    <button 
                                    onClick={() => handleDownload(file.content)} 
                                    className="underline cursor-pointer">
                                        View Details
                                    </button>
                                </td>
                            </tr>
                            ))
                    ):(
                        <tr key="no-data-row">
                            <td key="no-data-cell" colSpan="4" className="text-center py-4 text-gray-500 border-b">
                            No files found!
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    )
}

export default ShowDocuments;